'use strict';

var index = require('../packages/aviary-tokens/dist/cjs/index.cjs');

var cjsExports = index.__require();

exports.cjsExports = cjsExports;
//# sourceMappingURL=index2.cjs.map
